"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledGrid = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const Unstable_Grid2_1 = __importDefault(require("@mui/material/Unstable_Grid2"));
const PREFIX = "Grid";
exports.classes = {
    item: `${PREFIX}-item`,
    justifyContent: `${PREFIX}-justifyContent`
};
exports.StyledGrid = (0, styles_1.styled)(Unstable_Grid2_1.default)(({ theme }) => ({
    [`&.${exports.classes.justifyContent}`]: {
        [`.${exports.classes.item}:nth-of-type(4):nth-last-of-type(2)`]: {
            [theme.breakpoints.up("xl")]: {
                marginLeft: "20px"
            }
        }
    }
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2dyaWQvc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGlEQUE4QztBQUM5QyxrRkFBbUQ7QUFFbkQsTUFBTSxNQUFNLEdBQUcsTUFBTSxDQUFDO0FBRVQsUUFBQSxPQUFPLEdBQUc7SUFDckIsSUFBSSxFQUFFLEdBQUcsTUFBTSxPQUFPO0lBQ3RCLGNBQWMsRUFBRSxHQUFHLE1BQU0saUJBQWlCO0NBQzNDLENBQUM7QUFFVyxRQUFBLFVBQVUsR0FBRyxJQUFBLGVBQU0sRUFBQyx3QkFBTyxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ3hELENBQUMsS0FBSyxlQUFPLENBQUMsY0FBYyxFQUFFLENBQUMsRUFBRTtRQUMvQixDQUFDLElBQUksZUFBTyxDQUFDLElBQUkscUNBQXFDLENBQUMsRUFBRTtZQUN2RCxDQUFDLEtBQUssQ0FBQyxXQUFXLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxDQUFDLEVBQUU7Z0JBQzVCLFVBQVUsRUFBRSxNQUFNO2FBQ25CO1NBQ0Y7S0FDRjtDQUNGLENBQUMsQ0FBQyxDQUFDIn0=